import { useCallback, useEffect, useState } from 'react';
export var VideoPlayerAutoPlayState;
(function (VideoPlayerAutoPlayState) {
    VideoPlayerAutoPlayState["Playing"] = "playing";
    VideoPlayerAutoPlayState["Paused"] = "paused";
})(VideoPlayerAutoPlayState || (VideoPlayerAutoPlayState = {}));
export const useVideoPlayerAutoplay = (videoPlayerElement) => {
    var _a;
    const [isPlaying, setIsPlaying] = useState(false);
    const [playState, setPlayState] = useState(VideoPlayerAutoPlayState.Paused);
    const { autoplay } = ((_a = videoPlayerElement.current) === null || _a === void 0 ? void 0 : _a.dataset) || {};
    const pause = useCallback(() => {
        var _a;
        (_a = videoPlayerElement === null || videoPlayerElement === void 0 ? void 0 : videoPlayerElement.current) === null || _a === void 0 ? void 0 : _a.pause();
        setPlayState(VideoPlayerAutoPlayState.Paused);
    }, [videoPlayerElement]);
    const play = useCallback(() => {
        var _a;
        (_a = videoPlayerElement === null || videoPlayerElement === void 0 ? void 0 : videoPlayerElement.current) === null || _a === void 0 ? void 0 : _a.play().catch((error) => {
            console.warn('useVideoPlayerAutoplay: play failed due to', error);
        });
        setPlayState(VideoPlayerAutoPlayState.Playing);
    }, [videoPlayerElement]);
    const togglePlaying = useCallback(() => {
        var _a, _b, _c;
        if ((_a = videoPlayerElement.current) === null || _a === void 0 ? void 0 : _a.paused) {
            (_b = videoPlayerElement === null || videoPlayerElement === void 0 ? void 0 : videoPlayerElement.current) === null || _b === void 0 ? void 0 : _b.play().catch((error) => {
                console.warn('useVideoPlayerAutoplay: play failed due to', error);
            });
            setPlayState(VideoPlayerAutoPlayState.Playing);
        }
        else {
            (_c = videoPlayerElement === null || videoPlayerElement === void 0 ? void 0 : videoPlayerElement.current) === null || _c === void 0 ? void 0 : _c.pause();
            setPlayState(VideoPlayerAutoPlayState.Paused);
        }
    }, [videoPlayerElement]);
    useEffect(() => {
        if (!videoPlayerElement.current)
            return;
        let timeout;
        if (videoPlayerElement && autoplay) {
            timeout = setTimeout(() => {
                var _a;
                (_a = videoPlayerElement === null || videoPlayerElement === void 0 ? void 0 : videoPlayerElement.current) === null || _a === void 0 ? void 0 : _a.play().catch((error) => {
                    // .catch() Necessary to prevent runtime errors in Safari.
                    console.warn('useVideoPlayerAutoplay: play failed due to', error);
                });
                setPlayState(VideoPlayerAutoPlayState.Playing);
            }, 0);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [videoPlayerElement, isPlaying, autoplay]);
    return {
        playState,
        autoPlay: () => setIsPlaying(true),
        pause,
        play,
        togglePlaying,
    };
};
